import styled from "styled-components";

export const LanguageButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: transparent;
  color: white;
  border: transparent;
`;